<template>
  <div class="uniform">
    <div class="itemList" v-if="stockList.cat && Object.keys(infoList).length != 0">
      <div class="uniformList" v-for="(lists, key, indexs) in stockList.stock" :key="indexs">
        <div class="flex child" v-if="childrenList[key]">
          <van-image round width="44px" height="44px" :src="childrenList[key].avatar" class="avatar-1 mr-10" />
          <div class="item-1-1 flex1">
            <div class="color3 font14 fontWeight">{{ childrenList[key].name }}</div>
            <div class="color6 font12 pt-3">{{ childrenList[key].class_name }}</div>
          </div>
          <!-- <img src="@/assets/shipping.png" alt="Logo" width="20px" height="20px" /> -->
        </div>
        <!-- <van-divider /> -->
        <div v-for="(list, key1, index) in lists" :key="index">
          <div class="font12 color3 mb-15 flex align-items">
            <img src="@/assets/classify.png" alt="Logo" width="20px" /><span class="ml-5">{{ stockList.cat[key1].title }}</span>
          </div>
          <div v-for="(_item, idx) in list" :key="idx" class="listShop">            
            <div v-if="_item.status == 1 && !_item.is_delete">
              <van-swipe-cell>
                <div class="flex alignStart">
                  <van-checkbox v-model="_item.check" @change="shopCheck" :disabled="_item.is_delete || (_item.num < getQuantity(key, _item.original_key) && _item.unlimited == 0)">
                    <span class="relative">
                      <img :src="_item.img" class="img72 mr-10" />
                      <span class="labelSuit" v-if="_item.bundle_items && _item.bundle_items.length > 0">套装</span>
                    </span>
                  </van-checkbox>
                  <div class="flex1">
                    <div class="color3 font14 fontWeight">{{ _item.title }} <span class="presale" v-if="_item.num <= 0 && _item.presale == 1">预售</span></div>
                    <div class="font12 color6 mt-5 flex align-items">
                      <span class="flex1" v-if="!_item.is_bundles">{{ _item.attr1 }} / {{ _item.attr2 }}</span>
                      <span v-else class="flex1">{{ _item.attr2 }} / 共{{ getBundleNum(_item.bundle_items) }}件商品</span>
                      <span v-if="_item.unlimited == 0">{{ $t("uniform.Stock_Quantity") }}{{ _item.num >=0 ? _item.num : 0}}</span>
                      <span class="colorRed font12" v-else-if="_item.is_delete">{{ $t("uniform.Invalid_Item") }}</span>
                    </div>
                    <div class="flex align-items mt-5">
                      <div class="flex1 font14">
                        <span class="colorRed fontWeight">¥ {{ _item.unit_price }} </span>
                        <span class="van-card__origin-price" v-if="_item.scribing_price != ''">¥ {{ _item.scribing_price }}</span>
                      </div>
                      <div class="flex align-items">
                        <span class="colorRed font12" v-if="_item.num < getQuantity(key, _item.original_key) && _item.unlimited == 0">{{ $t("uniform.out_of_stock") }}</span>
                        
                        <div class="van-stepper van-sku__stepper">
                          <button type="button" class="van-stepper__minus" :class="getQuantity(key, _item.original_key) == 1 ? 'van-stepper__minus--disabled' : ''" @click="subtract(_item, key, _item.original_key)"></button>
                          <input type="tel" v-if="infoList[key][_item.original_key] && infoList[key][_item.original_key].num" v-model="infoList[key][_item.original_key].num" class="van-stepper__input" />
                          <input type="tel" v-else v-model="infoList[key][_item.original_key]" class="van-stepper__input" />
                          <button type="button" class="van-stepper__plus" :class="getQuantity(key, _item.original_key) >= _item.num && _item.unlimited == 0 ? 'van-stepper__minus--disabled' : ''" @click="plus(_item, key, _item.original_key)"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template #right>
                  <van-button square :text="$t('global.delete')" type="danger" class="delete-button" @click="remove(_item, key, key1, _item.original_key, idx)" />
                </template>
              </van-swipe-cell>
              <div class="suitDetails" v-if="_item.is_bundles">
                <van-row gutter="6">
                  <van-col span="12" v-for="(item, i) in _item.bundle_items" :key="i">
                    <div class="flex align-items mb-12">
                      <img :src="item.img" alt="" class="img44" />
                      <div class="ml-8 flex1 width0">
                        <div class="color3 font12 text-overflow">{{ item.title }}</div>
                        <div class="color6 font11 mt-5">{{ item.attr1 }} / {{ item.attr2 }}</div>
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>
            <div v-else>
              <van-swipe-cell>
                <div class="flex alignStart" style="opacity: 0.5">
                  <van-checkbox disabled>
                    <img :src="_item.img" alt="" class="img72" />
                  </van-checkbox>
                  <div class="flex1 flex ml-10">
                    <div class="flex1 ml-10">
                      <div class="color3 font14 fontWeight">{{ _item.title }}</div>
                      <div class="font12 color6 mt-5 flex align-items">
                        <span class="flex1">{{ _item.attr1 }} | {{ _item.attr2 }}</span>
                      </div>
                      <div class="flex align-items mt-10">
                        <div class="flex1 font14">
                          <span class="colorRed fontWeight">¥ {{ _item.unit_price }} </span>
                          <span class="van-card__origin-price" v-if="_item.scribing_price != ''">¥ {{ _item.scribing_price }}</span>
                        </div>
                        <div>
                          <span class="colorRed font12">{{ $t("uniform.Invalid_Item") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template #right>
                  <van-button square :text="$t('global.delete')" type="danger" class="delete-button" @click="remove(_item, key, key1, _item.original_key, idx)" />
                </template>
              </van-swipe-cell>
              <div class="suitDetails" v-if="_item.is_bundles" style="opacity: 0.5">
                <van-row gutter="6">
                  <van-col span="12" v-for="(item, i) in _item.bundle_items" :key="i">
                    <div class="flex align-items mb-12">
                      <img :src="item.img" alt="" class="img44" />
                      <div class="ml-8 flex1 width0">
                        <div class="color3 font12 text-overflow">{{ item.title }}</div>
                        <div class="color6 font11 mt-5">{{ item.attr1 }} / {{ item.attr2 }}</div>
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>
            <!-- <van-divider /> -->
            <!-- </div> -->
            <!-- <van-divider v-if="Object.keys(item).length == 1 && id + 1 < Object.keys(list).length" /> -->
          </div>
        </div>
      </div>
      <van-submit-bar :price="prices" class="submitBar" :loading="showLoad" :button-text="$t('uniform.Submit')" @submit="onSubmit" button-color="#4D88D2">
        <van-checkbox v-model="checkAll" @click="checkedAll($event)" ref="checkbox">{{ $t("uniform.Select_All") }} </van-checkbox>
      </van-submit-bar>
    </div>
    <div v-else-if="stockList.cat">
      <van-empty :description="$t('uniform.cart_empty')" class="mt-30" image="https://m2.files.ivykids.cn/cloud01-file-8025768Fpkv74gsyXNIWDf0HfWgAyaI0Smi.png" />
    </div>
  </div>
</template>

<script>
import storage from "store";
import Vue from "vue";
import { CURRENT_CHILD, UNIFORM_SHOPPING } from "@/store/mutation-types";
import i18n from "../i18n";
import { NoticeBar, ActionSheet, Empty, Toast, Icon, GoodsAction, GoodsActionIcon, GoodsActionButton, Sku, SwipeCell, SubmitBar, Checkbox, Divider, Card } from "vant";
import { childList } from "@/api/child";
import { getStock, submitOrderCheck } from "@/api/uniform";
import store from "../store";
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Sku);
Vue.use(SwipeCell);
Vue.use(SubmitBar);
Vue.use(Divider);
Vue.use(Checkbox);
Vue.use(Card);
export default {
  name: "lunch",
  components: {},
  data() {
    return {
      infoList: {},
      checkAll: true,
      child_id: "",
      uniformList: [],
      shopNum: 0,
      result: [],
      prices: 0,
      childrenList: {},
      pay: null,
      childData: {},
      stockList: {},
      showLoad: false,
    };
  },
  beforeCreate() {
    // document.querySelector("body").setAttribute("style", "background-color:#fff;");
  },
  mounted() {
    let schoolType = store.getters.wxState || "ds";
    document.title = schoolType == "ds" ? this.$t("router.uniform") : this.$t("router.Purchase");
  },
  created() {
    this.showLoad = false;
    childList().then((res) => {
      res.data.forEach((item) => {
        this.childrenList[item.id] = item;
      });
    });
    this.childData = storage.get(CURRENT_CHILD + i18n.locale);
    this.child_id = this.childData.id;
    let data = storage.get(UNIFORM_SHOPPING + "_" + this.childData.family_id) || {};
    this.infoList = data.shopping ? data.shopping : {};
    getStock({ data: this.infoList }).then((res) => {
      this.pay = res.data.once;
      this.check(res.data.stock, true);
      this.stockList = res.data;
      this.getPrices();
    });
  },
  methods: {
    // 获取数量（兼容新旧数据结构）
    getQuantity(child_id, key) {
      let info = this.infoList[child_id] && this.infoList[child_id][key];
      if (!info) return 0;
      if (typeof info === 'object' && info !== null && typeof info.num === 'number') {
        return info.num;
      }
      return typeof info === 'number' ? info : 0;
    },
    check(data, bool) {
      for (let item in data) {
        if (typeof data[item] == "object") {
          // 处理数组（bundle_items）
          if (Array.isArray(data[item])) {
            data[item].forEach((bundleItem) => {
              if (bundleItem.title && bundleItem.status == 1 && !bundleItem.is_delete) {
                let qty = this.getQuantity(bundleItem.child_id, bundleItem.original_key);
                if (bundleItem.num >= qty || bundleItem.unlimited == 1) {
                  this.shopNum += 1;
                  bundleItem.check = bool;
                }
              }
            });
          } else {
            // 处理对象
            if (data[item].title && data[item].status == 1 && !data[item].is_delete) {
              let qty = this.getQuantity(data[item].child_id, data[item].original_key);
              if (data[item].num >= qty || data[item].unlimited == 1) {
                this.shopNum += 1;
                data[item].check = bool;
              }
            }
            this.check(data[item], bool);
          }
        }
      }
    },
    getPrices() {
      this.result = this.totalPrices(this.stockList.stock, []);
      let total=0
      this.result.forEach((item) => {
        if (typeof item === 'object' && item !== null && item.num) {
          // 套装商品：取 num 值
         total += item.num;
        } else if (typeof item === 'number') {
          // 普通商品：直接取数值
         total += item;
        }
      })
      this.prices = Math.round(Number(total) * 100);
    },
    totalPrices(data, children) {
      for (let item in data) {
        if (typeof data[item] == "object" &&  data[item]) {
          let qty = this.getQuantity(data[item].child_id, data[item].original_key);
          if (data[item].status == 1 && !data[item].is_delete && (data[item].num >= qty || data[item].unlimited == 1)) {
            this.checkNum += 1;
          }
          if (data[item].check && data[item].status == 1 && !data[item].is_delete && (data[item].num >= qty || data[item].unlimited == 1)) {
            children.push(qty * data[item].unit_price);
          }
          this.totalPrices(data[item], children);
        }
      }
      return children;
    },
    checkedAll() {
      this.shopNum = 0;
      this.check(this.stockList.stock, this.$refs.checkbox.value);
      this.getPrices();
    },
    shopCheck() {
      this.checkNum = 0;
      this.getPrices();
      let totalCount = this.getTotalCount(this.stockList.stock);
      if (totalCount == this.result.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    getTotalCount(data) {
      let count = 0;
      for (let childId in data) {
        let childData = data[childId];
        for (let paidKey in childData) {
          let list = childData[paidKey];
          if (Array.isArray(list)) {
            list.forEach(item => {
              if (!item.is_delete) {
                count += 1;
              }
            });
          }
        }
      }
      return count;
    },
    pushItem() {
      this.show = true;
    },
    //加
    plus(item, key, original_key) {
      let qty = this.getQuantity(key, original_key);
      if (qty >= item.num && item.unlimited == 0) {
        return;
      }
      let info = this.infoList[key][original_key];
      if (info && typeof info === 'object' && typeof info.num === 'number') {
        this.infoList[key][original_key].num++;
      } else {
        this.infoList[key][original_key]++;
      }
      this.getPrices();
      let shop = {
        shopping: this.infoList,
        order: {},
      };
      storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
    },
    //减
    subtract(item, key, original_key) {
      let qty = this.getQuantity(key, original_key);
      if (qty <= 1) {
        return;
      }
      let info = this.infoList[key][original_key];
      if (info && typeof info === 'object' && typeof info.num === 'number') {
        this.infoList[key][original_key].num--;
      } else {
        this.infoList[key][original_key]--;
      }
      this.getPrices();
      this.shopCheck();
      let shop = {
        shopping: this.infoList,
        order: {},
      };
      storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
    },
    //删除
    remove(item, key, key1, original_key, index) {
      this.$delete(this.infoList[key], original_key);
      this.stockList.stock[key][key1].splice(index, 1);
      if (Object.keys(this.infoList[key]).length === 0) {
        this.$delete(this.infoList, key);
        this.$delete(this.stockList.stock, key);
      }
      this.getPrices();
      let shop = {
        shopping: this.infoList,
        order: {},
      };
      if (Object.keys(this.infoList).length === 0) {
        storage.remove(UNIFORM_SHOPPING + "_" + this.childData.family_id);
      } else {
        storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
      }
      Toast.success(this.$t("uniform.Success"));
    },
    confirmOrder(data, children) {
      for (let item in data) {
        if (typeof data[item] == "object" && !data[item].is_bundle_item) {
          if (data[item].check) {
            data[item].stock = this.getQuantity(data[item].child_id, data[item].original_key);
            children.push(data[item]);
          }
          this.confirmOrder(data[item], children);
        }
      }
      return children;
    },
    getBundleNum(bundle_items) {
      let num = 0;
      bundle_items.forEach((item) => {
        num += item.quantity;
      });
      return num;
    },
    onSubmit() {
      var result = this.confirmOrder(this.stockList.stock, []);
      if (result.length == 0) {
        return;
      }
      this.showLoad = true;
      let product = {};
      result.forEach((item) => {
        if (product[item.child_id]) {
          product[item.child_id].push({
            paid: item.paid,
            num: item.stock,
            pid: item.pid,
            presale_order: item.presale,
          });
        } else {
          product[item.child_id] = [];
          product[item.child_id].push({
            paid: item.paid,
            num: item.stock,
            pid: item.pid,
            presale_order: item.presale,
          });
        }
      });
      submitOrderCheck({ product }).then((res) => {
        if (res.code == 0) {
          let shop = {
            order: result,
            shopping: this.infoList,
          };
          storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
          this.$router.push({
            name: "UniformConfirm",
          });
        } else {
          this.showLoad = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.relative {
  position: relative;
}
.labelSuit {
  width: 72px;
  height: 16px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 12px;
  border-radius: 0 0 8px 8px;
  color: #fff;
  text-align: center;
  line-height: 16px;
  background: rgba(0, 0, 0, 0.5);
}
.presale {
  background: #5cb85c;
  display: inline-block;
  line-height: 4vw;
  float: right;
  border-radius: 50px;
  color: #fff;
  font-size: 3.2vw;
  display: inline-block;
  padding: 2px 4px;
  z-index: 99;
}
.img72 {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: contain;
}

.uniformList {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin: 12px 8px;
}

.align-items {
  align-items: center;
}

.colorRed {
  color: #ee0a24;
}

.fontWeight {
  font-weight: 500;
}

.word-break {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.word-break2 {
  overflow: hidden; //超出文本隐藏
  text-overflow: ellipsis; ///超出部分省略号显示
  display: -webkit-box; //弹性盒模型
  -webkit-box-orient: vertical; //上下垂直
  -webkit-line-clamp: 2; //自定义行数
  line-clamp: 2;
}

.goods-card {
  margin: 0;
}

.delete-button {
  height: 100%;
  margin: 0 0 0 10px;
  padding: 10px;
  border-radius: 0 4px 4px 0;
}

.van-submit-bar__button--danger {
  background-color: #4d88d2;
}

.itemList {
  margin-bottom: 60px;
}

.listShop {
  padding: 16px 0;
  border-top: 1px solid #f7f8fa;
}

.alignStart {
  align-items: start;
}

.van-stepper__input {
  pointer-events: none;
}

.child {
  align-items: center;
  background: linear-gradient(180deg, #e6eeff 0%, #ffffff 100%);
  margin: -12px;
  padding: 12px 12px 0;
  border-radius: 8px 8px 0px 0px;
  margin-bottom: 20px;
}

.uniform {
  overflow-y: scroll;
  height: 100vh;
}

.uniform::-webkit-scrollbar {
  display: none;
}
.suitDetails {
  padding: 12px 12px 0;
  background: #f7f8fa;
  border-radius: 8px;
  margin: 10px 0 0 28px;
  .img44 {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    object-fit: contain;
  }
  .font11 {
    font-size: 11px;
  }
  .width0{
    width: 0;
  }
  .text-overflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
<style>
.submitBar .van-submit-bar__text span {
  margin-left: 5px;
}
</style>
